import RedHeartIcon from '@/assets/images/icons/red-heart.svg?react';
import Icon from '@/components/icons/icon';
import type { IconProps } from '@/components/icons/icon.type';
import { useSymbolStore } from '@/stores/symbol';
import Selector from '../common/selector';
import SmileIcon from '../icons/smile-icon';
import StickerIcon from '../icons/sticker-icon';

const SymbolSelector = () => {
  const selectedSymbol = useSymbolStore((s) => s.selectedSymbol);

  const symbols = [
    {
      slug: 'emoji',
      item: <SmileIcon />,
    },
    {
      slug: 'sticker',
      item: <StickerIcon />,
    },
    {
      slug: 'custom-sticker',
      item: (
        <Icon>
          <RedHeartIcon className='size-10' />
        </Icon>
      ),
    },
  ];

  const select = (symbol: string) => {
    useSymbolStore.getState().setSelectedSymbol(symbol as 'emoji' | 'sticker' | 'custom-sticker');
  };

  return (
    <Selector<IconProps>
      className='mt-2 justify-start px-2 gap-2'
      items={symbols}
      itemProps={{
        svgClass: 'size-8',
        className: 'p-2',
      }}
      selected={selectedSymbol}
      onSelect={(slug) => select(slug)}
      customSelectedClass='bg-secondary rounded-lg'
    />
  );
};

export default SymbolSelector;
